<div>
  <div class="card-sub-heading bold">Please make signature choice for delivery:</div>
  <div class="mt-4">
    <mat-radio-group class="d-flex flex-column" [(ngModel)]="status">
      <mat-radio-button class="mb-2" color="primary" *ngFor="let item of signatureItems" [value]='item.id'>
        {{item.name}}
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="d-flex align-items-center justify-content-between mt-5">
    <button class="custom-btn" mat-dialog-close>Cancel</button>
    <button class="custom-btn" [mat-dialog-close]="status">Save</button>
  </div>
</div>